import { useState } from 'react';
import { dismissTriage } from 'services/escriturasTriageService';

const REASON_VALUES = ['spam', 'duplicate', 'not_applicable', 'other'];

export default function TriageDismissModal({ DesignSystemComponents, detail, t, onClose, onResolved }) {
  const { Modal, Button, Dropdown } = DesignSystemComponents ?? {};

  const [reason, setReason] = useState('spam');
  const [reasonDetail, setReasonDetail] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const reasonOptions = REASON_VALUES.map((value) => ({
    label: t(`triage_dismiss_reason_${value}`),
    value,
  }));
  const selectedReasonOption = reasonOptions.find((o) => o.value === reason);

  const handleConfirm = async () => {
    setSending(true);
    setError(null);
    try {
      const label = t(`triage_dismiss_reason_${reason}`);
      const fullReason = reasonDetail ? `${label}: ${reasonDetail}` : label;
      const result = await dismissTriage(detail.id, { reason: fullReason });
      onResolved(result?.message);
    } catch (err) {
      setError(err.response?.data?.message || err.message || t('triage_error_generic'));
      setSending(false);
    }
  };

  const body = (
    <div>
      <p className='font-light mb-3' style={{ fontSize: 13 }}>{t('triage_dismiss_hint')}</p>

      {error && <div className='alert alert-danger py-2' style={{ fontSize: 13 }}>{error}</div>}

      <label className='form-label fw-semibold' style={{ fontSize: 13 }}>
        {t('triage_dismiss_reason_label')}
      </label>
      {Dropdown ? (
        <div className='mb-2'>
          <Dropdown
            options={reasonOptions}
            value={selectedReasonOption}
            onChange={(option) => setReason(option?.value || 'spam')}
            width='100%'
          />
        </div>
      ) : (
        <select
          className='form-select form-select-sm mb-2'
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        >
          {reasonOptions.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      )}

      <label className='form-label fw-semibold' style={{ fontSize: 13 }}>
        {t('triage_dismiss_detail_label')}
      </label>
      <textarea
        className='form-control form-control-sm mb-3'
        rows={2}
        value={reasonDetail}
        onChange={(e) => setReasonDetail(e.target.value)}
      />

      <div className='d-flex justify-content-end gap-2'>
        {Button ? (
          <>
            <Button label={t('triage_btn_cancel')} size='sm' variant='secondary' onClick={onClose} disabled={sending} />
            <Button
              label={sending ? t('triage_sending') : t('triage_btn_dismiss')}
              size='sm'
              variant='primary'
              onClick={handleConfirm}
              disabled={sending}
            />
          </>
        ) : (
          <>
            <button type='button' className='btn btn-outline-secondary btn-sm' onClick={onClose} disabled={sending}>
              {t('triage_btn_cancel')}
            </button>
            <button type='button' className='btn btn-primary btn-sm' onClick={handleConfirm} disabled={sending}>
              {sending ? t('triage_sending') : t('triage_btn_dismiss')}
            </button>
          </>
        )}
      </div>
    </div>
  );

  if (!Modal) {
    return (
      <div
        role='dialog'
        style={{
          position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', zIndex: 9500,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32,
        }}
        onClick={onClose}
      >
        <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 8, padding: 20, width: 'min(520px, 92vw)' }}>
          <h5>{t('triage_dismiss_title')}</h5>
          {body}
        </div>
      </div>
    );
  }
  return (
    <Modal title={t('triage_dismiss_title')} show onClose={onClose} size='md'>
      {body}
    </Modal>
  );
}
